/**
 * O painel de UM item — `/admin/configuracoes/:secao/:item` (K-2 da rodada CASCA).
 *
 * A moldura já está montada por volta, e o cabeçalho também: título, descrição e
 * ação do item são desenhados pela casca. Aqui entra **só o conteúdo**.
 *
 * ⚠️ Este componente teve um `<h2>` próprio até o K-4. Somado ao título da casca
 * e ao `PageHeader` que a tela embutida trazia, a palavra "Tags" aparecia TRÊS
 * vezes na mesma página. Se voltar a desenhar cabeçalho aqui, o teste
 * `uma-voz-so.test.tsx` acusa.
 */
import { Navigate, useParams } from 'react-router-dom';

import { EmptyState } from '@/components/ui';
import { componenteDoItem } from './itens-registry';
import { useSecoesPermitidas } from './secoes';

export function ItemPainel() {
  const { secao, item } = useParams<{ secao: string; item: string }>();
  const secoes = useSecoesPermitidas();

  const secaoAtual = secoes.find((s) => s.id === secao);
  const itemAtual = secaoAtual?.itens.find((i) => i.id === item);

  // Item que não existe, ou que existe e esta pessoa não alcança: manda para o
  // índice da seção em vez de mostrar erro. `useSecoesPermitidas` já filtrou por
  // permissão, então "não achou" cobre os dois casos — e a diferença entre eles
  // não é do interesse de quem está usando.
  if (!secaoAtual || !itemAtual) {
    return <Navigate to={`/admin/configuracoes/${secao ?? ''}`} replace />;
  }

  const Componente = componenteDoItem(secaoAtual.id, itemAtual.id);

  // Item catalogado mas ainda não migrado (ver `itens-registry.tsx`). Não é erro
  // — é obra em andamento, e a tela diz isso em vez de fingir que quebrou.
  if (!Componente) {
    return (
      <EmptyState
        title={itemAtual.nome}
        description="Esta configuração ainda abre pela tela antiga. Use o item no menu para chegar nela."
        tamanho="compacto"
      />
    );
  }

  // K-4: SEM cabeçalho próprio. O título e a descrição do item já são
  // desenhados pela casca (`ConfiguracoesPage`), que é a única voz que diz onde
  // a pessoa está. Este componente entrega só o conteúdo.
  return <Componente />;
}
